module.exports = __webpack_public_path__ + "img/SA.c20266a5.svg";